import MyBread from '../../components/Breadcrumbs'
import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import Prefectures from 'components/PrefecturesOption';
import config from 'config';
import { removeKeyWithValue, getPrefectureNameByCode } from 'utils';
import IdSearchButton from 'components/IdSearchButton';
import { DeletedContents } from 'styles/styles';
import { Wrapper, PageTitle, CreateNew, ModalStyle, FormLabel, FormSelect, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose, DivMargin } from 'styles/styles';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ChildProps {
  data: ChildDataProps[];
  setIsChildDataInsert: Dispatch<SetStateAction<boolean>>;
  selectedId: number;
}

interface ParentDataProps {
  customer_id: number
  name: string
  name_kana: string
  abbreviation: string
  postcode: string
  prefecture_id: number
  city: string
  block: string
  building: string
  phone_number: string
  fax_number: string
  representative: string
  delivery_date: number
  display_id: string
  [key: string]: string | number;
}

interface ChildDataProps {
  customer_id: number
  display_id: string
  department_name: string
  name: string
  name_kana: string
  charged_user_id: number
  charged_user_display_id: string
  charged_user_name: string
  phone_number: string
  fax_number: string
  [key: string]: string | number;
}

const Parent = ({ data, selectedId, setSelectedId, setIsParentDataInsert }: ParentProps) => {
  const auth = useAuth();
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, watch, formState: { errors } } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined) {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      name: submitData.name,
      name_kana: submitData.name_kana,
      abbreviation: submitData.abbreviation,
      postcode: submitData.postcode,
      prefecture_id: submitData.prefecture_id,
      city: submitData.city,
      block: submitData.block,
      building: submitData.building,
      phone_number: submitData.phone_number,
      fax_number: submitData.fax_number,
      representative: submitData.representative,
      delivery_date: submitData.delivery_date,
      display_id: submitData.display_id,
    }
    try {
      setIsSubmitDisable(true);
      if (selectedId === 0) {
        await axios.post(`/v0/factories/${auth.factoryId}/customers`, branchData, {
          headers: auth.authorizationHeader
        });
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/factories/${auth.factoryId}/customers`, branchData, {
          headers: auth.authorizationHeader,
          params: { id: selectedId }
        });
        window.alert("変更が完了しました");
      }
      close();
      setIsParentDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'customer_id' },
  { title: '連携済み', field: 'is_linked' },
  { title: '共有ID', field: 'share_code' },
  { title: '得意先ID', field: 'display_id', default: 'customer-1', type: 'alphanumeric', required: true },
  { title: '得意先', field: 'name', default: '株式会社test', type: 'text', required: true },
  { title: '得意先(カナ)', field: 'name_kana', default: 'カブシキガイシャテスト', type: 'text' },
  { title: '略称', field: 'abbreviation', default: 'test', type: 'text' },
  { title: '郵便番号', field: 'postcode', default: '1111111', type: 'number' },
  { title: '都道府県', field: 'prefecture_id', default: '', select: 'prefecture' },
  { title: '市区町村', field: 'city', default: '2', type: 'text' },
  { title: '番地', field: 'block', default: '3', type: 'text' },
  { title: '建物名以下', field: 'building', default: '4', type: 'text' },
  { title: '電話番号', field: 'phone_number', default: '22222222', type: 'tel' },
  { title: 'FAX', field: 'fax_number', default: '33333333', type: 'tel' },
  { title: '代表者名', field: 'representative', default: '代表者名', type: 'text' },
  { title: '出荷予定日初期値', field: 'delivery_date', default: 0, type: 'number', required: true }]
  const PAGE_TITLE = "得意先"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      const title = element.title;
      const field = element.field;
      const tmpObj = {
        title: title,
        field: field,
        render: (rowData: any) => {
          if (field === 'is_linked') {
            if (parseInt(rowData.is_linked)) {
              return (
                <CheckBoxIcon />
              );
            } else {
              return (
                <CheckBoxOutlineBlankIcon />
              );
            }
          } else {
            return rowData[field]
          }
        },
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      };
      columnsArray.push(tmpObj)
    }
  }
  const listItems = parentArray.map((element: any, index) => {
    if (element.title && element.field !== 'is_linked' && element.field !== 'share_code') {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            {element.select === "prefecture" ?
              <FormSelect {...register("prefecture_id")}>
                <option hidden value={""}>都道府県を選択してください</option>
                {Prefectures.map((prefecture) => (
                  <option key={prefecture.code} value={prefecture.code}>
                    {prefecture.name}
                  </option>
                ))}
              </FormSelect> :
              <FormInput {...register(element.field)}
                {...(element.type && { type: config.inputErrorMessage[element.type].type })}
                {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
                {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
                {...(element.type && { title: config.inputErrorMessage[element.type].title })}
                {...(element.required && { required: true })}
                {...(element.disable && { disabled: true })}
                {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
                {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
                {...(element.field.includes("delivery_date") && { max: 255 })}
                {...(element.field.includes("postcode") && { max: 9999999 })}
              />}
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );
  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);

  //IDから既存の値を呼び出し
  async function setModalValue(customer_id: number) {
    if (customer_id === 0) {
      setSelectedId(0);
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedId(customer_id);
      try {
        axios.get(`/v0/factories/${auth.factoryId}/customers`, {
          headers: auth.authorizationHeader,
          params: { id: customer_id }
        }).then((res: any) => {
          reset(res.data[0]);
          setModalTitle("編集")
        });
      } catch (err) {
        console.log(err)
      }
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  }

  return (
    <>
      <CreateNew onClick={createNew}>新規作成</CreateNew>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: '編集する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.customer_id);
                  open();
                } catch (error) {
                  console.log(error)
                }
              }
            },
            {
              icon: 'delete',
              tooltip: '削除する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(`${rowData.display_id}を削除しますか？`);
                if (result) {
                  try {
                    await axios.delete(`/v0/factories/${auth.factoryId}/customers`, {
                      headers: auth.authorizationHeader,
                      params: { id: rowData.customer_id }
                    });
                    setIsParentDataInsert(true);
                    setSelectedId(0);
                  } catch (error: any) {
                    window.alert(error.response.data.error)
                  }
                }
              }
            },
            {
              icon: 'add',
              tooltip: '工場連携',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                if (parseInt(rowData.is_linked)) {
                  window.alert("すでに連携済みです");
                  return;
                }
                const shareCode = window.prompt("得意先の共有IDを入力してください", "ここに文字列を入力");
                let result = false;
                if (!shareCode) {
                  return;
                } else {
                  result = window.confirm(`連携しますか？`);
                }
                if (result) {
                  try {
                    await axios.patch(`/v0/customers/${rowData.customer_id}/share`, {
                      share_code: shareCode
                    }, {
                      headers: auth.authorizationHeader,
                      params: { factory_id: auth.factoryId }
                    });
                    window.alert(`工場連携が完了しました。`)
                    setIsParentDataInsert(true);
                    setSelectedId(0);
                  } catch (error: any) {
                    window.alert(error.response.data.error)
                  }
                }
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: 'nowrap' },
            rowStyle: (rowData) => ({
              overflowWrap: 'break-word',
              backgroundColor: selectedRow === rowData.tableData.id ? '#EEE' : '#FFF',
            })
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.customer_id);
            setSelectedRow(rowData.tableData.id);
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}


const Child = ({ data, setIsChildDataInsert, selectedId }: ChildProps) => {
  const auth = useAuth();
  const [selectedBranch, setSelectedBranch] = React.useState(0);
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [pageSize, setPageSize] = React.useState(5);
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, watch, setValue, formState: { errors } } = useForm<ChildDataProps>();
  const onSubmit: SubmitHandler<ChildDataProps> = async (submitData: ChildDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined) {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      display_id: submitData.display_id,
      department_name: submitData.department_name,
      name: submitData.name,
      name_kana: submitData.name_kana,
      charged_user_id: submitData.charged_user_id,
      phone_number: submitData.phone_number,
      fax_number: submitData.fax_number,
    }
    try {
      setIsSubmitDisable(true);
      if (!selectedBranch) {
        await axios.post(`/v0/customers/${selectedId}/branches`, branchData, {
          headers: auth.authorizationHeader,
          params: { factory_id: auth.factoryId }
        });
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/customers/${selectedId}/branches`, branchData, {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: selectedBranch,
            factory_id: auth.factoryId
          }
        });
        window.alert("変更が完了しました");
      }
      close();
      setIsChildDataInsert(true);
    } catch (error: any) {
      console.log(error)
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'customer_id' },
  { title: '', field: 'customer_branch_id' },
  { title: '枝番', field: 'display_id', default: '00', type: 'branch', required: true },
  { title: '部門名', field: 'department_name', default: '開発', type: 'text' },
  { title: '担当者名', field: 'name', default: '開発太郎', type: 'text' },
  { title: '担当者名（カナ）', field: 'name_kana', default: 'カイハツタロウ', type: 'text' },
  { title: '', field: 'charged_user_id' },
  { title: '', field: 'charged_user_is_deleted' },
  { title: '自社担当者ID', field: 'charged_user_display_id', default: '', disable: true },
  { title: '自社担当者名', field: 'charged_user_name', default: '', disable: true, search: "users" },
  { title: '電話番号', field: 'phone_number', default: '02333333333', type: 'tel' },
  { title: 'FAX', field: 'fax_number', default: '13412412412', type: 'tel' },
  ]
  const PAGE_TITLE = "得意先枝番"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];

  function isConditionSatisfied(rowData: any, field: string): boolean {
    return (
      rowData.charged_user_is_deleted && (field === 'charged_user_display_id' || field === 'charged_user_name')
    );
  }

  for (const element of parentArray) {
    if (element.title) {
      const title = element.title;
      const field = element.field;
      const tmpObj = {
        title: title,
        field: field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        render: (rowData: any) => {
          if (isConditionSatisfied(rowData, field)) {
            return (
              <DeletedContents>
                {rowData[field]}
              </DeletedContents>
            );
          } else {
            return rowData[field]
          }
        }
      };
      columnsArray.push(tmpObj)
    }
  }

  const [selectedUserContents, setSelectedUserContents] = useState<any>('');

  useEffect(() => {
    setValue('charged_user_id', selectedUserContents.user_id);
    setValue('charged_user_display_id', selectedUserContents.display_id);
    setValue('charged_user_name', selectedUserContents.name);
  }, [selectedUserContents])

  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
            {element.search === "users" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedUserContents} /> : <></>}
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );
  //カラムなど生成ここまで

  const defaultMaterialTheme = createTheme();

  //IDから既存の値を呼び出し
  async function setModalValue(customer_branch_id: number) {
    if (!customer_branch_id) {
      setSelectedBranch(0);
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedBranch(customer_branch_id);
      const result: any = await axios.get(`/v0/customers/${selectedId}/branches`, {
        headers: auth.authorizationHeader,
        params: {
          selected_branch: customer_branch_id,
          factory_id: auth.factoryId
        }
      });
      reset(result.data[0]);
      setModalTitle("編集")
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  }

  return (
    <>
      {selectedId === 0 ? "" : <CreateNew onClick={createNew}>新規作成</CreateNew>}
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: '編集する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.customer_branch_id);
                  open();
                } catch (error) {
                  console.log(error);
                }
              }
            },
            {
              icon: 'delete',
              tooltip: '削除する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(`${rowData.display_id}を削除しますか？`);
                if (result) {
                  try {
                    await axios.delete(`/v0/customers/${selectedId}/branches`, {
                      headers: auth.authorizationHeader,
                      params: {
                        selected_branch: rowData.customer_branch_id,
                        factory_id: auth.factoryId
                      }
                    });
                    setIsChildDataInsert(true);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: 'nowrap' },
            rowStyle: { overflowWrap: 'break-word' }
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}

export default function Customers() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [isChildDataInsert, setIsChildDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [childData, setChildData] = useState<ChildDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    try {
      axios.get(`/v0/factories/${auth.factoryId}/customers`, {
        headers: auth.authorizationHeader
      }).then((res: any) => {
        if (res.data.length) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].prefecture_id = res.data[i].prefecture_id ? getPrefectureNameByCode(res.data[i].prefecture_id) : '';
          }
          setParentData(res.data);
        } else {
          setParentData([]);
        }
        setIsParentDataInsert(false)
      })
    } catch (err) {
      console.log(err)
    }
  }, [auth, isParentDataInsert]);

  useEffect(() => {
    if (selectedId === 0) {
      setChildData([]);
    } else {
      try {
        axios.get(`/v0/customers/${selectedId}/branches`, {
          headers: auth.authorizationHeader,
          params: {
            factory_id: auth.factoryId
          }
        }).then((res: any) => {
          if (res.data.length) {
            setChildData(res.data)
          } else {
            setChildData([]);
          }
          setIsChildDataInsert(false)
        })
      } catch (err) {
        console.log(err)
      }
    }
  }, [auth, selectedId, isChildDataInsert])

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>得意先マスタ</PageTitle>
        <Parent data={parentData} selectedId={selectedId} setSelectedId={setSelectedId} setIsParentDataInsert={setIsParentDataInsert} />
        <DivMargin></DivMargin>
        <Child data={childData} selectedId={selectedId} setIsChildDataInsert={setIsChildDataInsert} />
      </Wrapper>
    </>
  )
}